
import Cookies from "js-cookie";
const handleLogout = async () => {
    try {
      Cookies.set('mgltokenprevious', null, { expires: 7, domain: process.env.REACT_APP_DOMAIN });
      Cookies.remove('mgltokenprevious', { path: '/' }); // Add path if needed
      Cookies.set('mgltoken', null, { expires: 7, domain: process.env.REACT_APP_DOMAIN });
      Cookies.remove('mgltoken', { path: '/' }); // Add path if needed
      localStorage.setItem('lasturl', null);
      window.location.href = "/"
    } catch (error) {
      console.log(error)
    }
};

export default handleLogout